export const ITEMS_VOLUME_INPUT_MAX_VALUE = 100000;
export const ITEMS_VOLUME_INPUT_MIN_VALUE = 1;

export const SCAN_INFO_MODAL_CLOSE_DELAY = 3000; // 3 seconds in milliseconds
export const SCAN_INFO_MODAL_UPDATE_INTERVAL = 30; // Update progress every 30ms for smooth animation
